import { useQueryClient, useMutation } from "@tanstack/react-query";
import { Button, Input } from "antd";
import React, { useState } from "react";
import { updateExpert } from "../../../service/api";
import { EditOutlined } from "@ant-design/icons";

function BankInfo({ expertData }) {
  const [bankAccount, setBankAccount] = useState({});
  const [hideBtn, setHideBtn] = useState(true);
  const [loading, setLoading] = useState();
  const queryClient = useQueryClient();
  const mutation = useMutation(updateExpert, {
    onMutate: () => {
      setLoading(true);
    },
    onSuccess: () => {
      setHideBtn(true);
      queryClient.invalidateQueries(["expertData"]);
      setLoading(false);
    },
  });

  return (
    <div className="bg-white rounded-2xl p-6 flex flex-col gap-2 w-full ">
      <h2 className="text-right font-body text-2xl font-bold text-[#005AC7] max-lg:text-[0.875rem]">
        اطلاعات بانکی
      </h2>
      <section className="flex  font-body justify-between max-lg:flex-col max-lg:m-auto">
        <div layout="vertical">
          <div className=" font-body flex flex-wrap gap-4 items-center justify-evenly  w-[60vw] max-lg:w-full">
            <div className="flex flex-col gap-2 items-start justify-center max-lg:w-full">
              <label>نام بانک</label>
              <Input
                onChange={(e) => {
                  setHideBtn(false);
                  setBankAccount({ ...bankAccount, bankName: e.target.value });
                }}
                defaultValue={
                  expertData?.modifiedExpert?.bankName &&
                  expertData?.modifiedExpert?.bankName !== "NOT_MODIFIED"
                    ? expertData?.modifiedExpert?.bankName
                    : expertData?.expert?.bankName
                }
              />
            </div>
            <div className="flex flex-col gap-2 items-start justify-center max-lg:w-full">
              <label>نام صاحب حساب</label>
              <Input
                onChange={(e) => {
                  setHideBtn(false);
                  setBankAccount({
                    ...bankAccount,
                    bankAccountHolderName: e.target.value,
                  });
                }}
                defaultValue={
                  expertData?.modifiedExpert?.bankAccountHolderName !==
                    "NOT_MODIFIED" &&
                  expertData?.modifiedExpert?.bankAccountHolderName
                    ? expertData?.modifiedExpert?.bankAccountHolderName
                    : expertData?.expert?.bankAccountHolderName
                }
              />
            </div>
            <div className="flex flex-col gap-2 items-start justify-center max-lg:w-full">
              <label>شماره حساب</label>
              <Input
                onChange={(e) => {
                  setHideBtn(false);
                  setBankAccount({
                    ...bankAccount,
                    bankAccountNumber: e.target.value,
                  });
                }}
                defaultValue={
                  expertData?.modifiedExpert?.bankAccountNumber !==
                    "NOT_MODIFIED" &&
                  expertData?.modifiedExpert?.bankAccountNumber
                    ? expertData?.modifiedExpert?.bankAccountNumber
                    : expertData?.expert?.bankAccountNumber
                }
              />
            </div>
            <div className="flex flex-col gap-2 items-start justify-center max-lg:w-full">
              <label>شماره شبا</label>
              <Input
              required
              maxLength={24}
              minLength={24}
                onChange={(e) => {
                  setHideBtn(false);
                  setBankAccount({
                    ...bankAccount,
                    bankIBANNumber: e.target.value,
                  });
                }}
                defaultValue={
                  expertData?.modifiedExpert?.bankIBANNumber !==
                    "NOT_MODIFIED" && expertData?.modifiedExpert?.bankIBANNumber
                    ? expertData?.modifiedExpert?.bankIBANNumber
                    : expertData?.expert?.bankIBANNumber
                }
                addonAfter={"IR"}
              />
            </div>
          </div>
        </div>
      </section>
      <div className="flex flex-row w-full justify-end max-lg:justify-center gap-8">
        <Button hidden={hideBtn} danger>
          لغو
        </Button>
        <Button icon={<EditOutlined/>} loading={loading} hidden={hideBtn} onClick={() => mutation.mutate(bankAccount)}>
          تایید
        </Button>
      </div>
    </div>
  );
}

export default BankInfo;
